import React from 'react';
import { Provider } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Routes from './routes';
import store from './store';
import axios from 'axios';
import setToken from './setToken';
import { configureSentry } from './utils/sentry';

const App = () => {
  const history = useHistory();

  configureSentry();

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          setToken();
          delete axios.defaults.headers.common['Authorization'];
          localStorage.removeItem('token');
          history.push('/login');
        } else if (error.response.status === 403) {
          setToken();
          delete axios.defaults.headers.common['Authorization'];
          localStorage.removeItem('token');
          history.push('/expired');
        }
      }
      return Promise.reject(error);
    },
  );

  return (
    <Provider store={store}>
      <Routes />
    </Provider>
  );
};

export default App;
